module.exports = __webpack_public_path__ + "img/news1.f08533c9.jpg";